import * as React from 'react'

export default () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.25 13.75V22C23.25 22.6904 22.6904 23.25 22 23.25H10C9.30964 23.25 8.75 22.6904 8.75 22V13.75H23.25Z"
      stroke="#8FB4FF"
      strokeWidth="1.5"
    />
    <path d="M8 11C8 9.89543 8.89543 9 10 9H22C23.1046 9 24 9.89543 24 11V13H8V11Z" fill="#8FB4FF" />
    <rect x="11" y="6" width="2" height="4" rx="1" fill="#8FB4FF" />
    <rect x="19" y="6" width="2" height="4" rx="1" fill="#8FB4FF" />
  </svg>
)
